import { Contract } from 'ethers';
import { ERC20Interface } from '../constants';
import { useCall } from './useCall';
/**
 * @public
 */
export function useTokenAllowance(tokenAddress, ownerAddress, spenderAddress, queryParams = {}) {
    var _a;
    const { value: allowance } = (_a = useCall(ownerAddress &&
        spenderAddress &&
        tokenAddress && {
        contract: new Contract(tokenAddress, ERC20Interface),
        method: 'allowance',
        args: [ownerAddress, spenderAddress],
    }, queryParams)) !== null && _a !== void 0 ? _a : {};
    return allowance === null || allowance === void 0 ? void 0 : allowance[0];
}
//# sourceMappingURL=useTokenAllowance.js.map